import React from 'react';
import Component from 'react-pure-render/component';
import PropTypes from 'prop-types';

import Panel from 'portaltransparencia-common/components/Panel.react.js';
import configuration from 'portaltransparencia-common/config/Config.js';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';
import TreeTable from 'portaltransparencia-common/components/treetable/TreeTable.react';
import TreeTableItem from 'portaltransparencia-common/components/treetable/TreeTableItem.react';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';

export class CargosTableOxy extends Component {
  static propTypes = {
    filter: PropTypes.string.isRequired,
    cargos: PropTypes.object.isRequired,
    expand: PropTypes.func.isRequired,
    collapse: PropTypes.func.isRequired
  };

  generateKey = cargo => {
    return `${cargo.id}`;
  };

  onClick = data => {
    const { entidade, exercicio } = StorageService.getItem('userInfo');
    const cargo = data.get('id');
    const matriz = data.get('matrizSalarialId');

    this.props.history.push(
      `/cargos/matriz-vigente?entidade=${entidade.id}&exercicio=${exercicio.id}&cargo=${cargo}&matriz=${matriz}`
    );
  };

  onClickItem = item => {
    const { expand, collapse } = this.props;

    if (item.get('open')) {
      collapse(
        item.get('id'),
        item.get('codigo'),
        item.get('planoSalarialEstruturaId'),
        item.get('planoSalarialId'),
        item.get('nivel')
      );
    } else {
      expand(
        item.get('id'),
        item.get('codigo'),
        item.get('planoSalarialEstruturaId'),
        item.get('planoSalarialId'),
        item.get('nivel')
      );
    }
  };

  renderItem = item => {
    const isPrimeiroNivel = item.get('nivel') == 1;
    let icon = isPrimeiroNivel ? 'fa fa-bar-chart' : 'fa fa-pie-chart';

    return (
      <TreeTableItem
        key={`${item.get('id')}-${item.get('codigo')}-${item.get(
          'nivel'
        )}-${item.get('planoSalarialId')}`}
        data={item}
        dataLevel={item.get('id')?.toString()}
        father={item.get('nivel') !== 4}
        level={item.get('nivel')}
        showButton={item.get('nivel') == 4}
        onClickButton={this.onClick}
        visible={item.get('visible')}
        iconGraph={icon}
        open={item.get('open')}
      >
        <td
          style={{ cursor: 'pointer' }}
          onClick={() => this.onClickItem(item)}
        >
          {item.get('codigo')}
        </td>
        <td>{item.get('descricao')}</td>
        <td className="right">{item.get('quantidadeVagas')}</td>
        <td className="right">{item.get('quantidadeVagasDisponiveis')}</td>
      </TreeTableItem>
    );
  };

  render() {
    const { cargos } = this.props;

    const header = (
      <TableHeader empty={cargos.isEmpty()}>
        <tr>
          <th>Código</th>
          <th>Descrição</th>
          <th className="right">Total de Vagas</th>
          <th className="right">Vagas Disponíveis</th>
          <th></th>
        </tr>
      </TableHeader>
    );

    return (
      <Panel isTable expansible={false} tableResponsive>
        <TreeTable
          list={cargos}
          header={header}
          itemRenderer={this.renderItem}
        />
      </Panel>
    );
  }
}

export default CargosTableOxy;
